import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, UnstyledButton } from '@mantine/core';

import { useGetUser } from 'api/account';
import { CalendarIcon, GlobeIcon } from 'icons';
import { LANGUAGE_LIST } from 'consts';
import { UserType } from 'types';

import { DataItem } from '../DataItem';
import { AppSettingsModal } from './AppSettingsModal';

export const AppSettings = () => {
  const { t } = useTranslation(['common', 'user']);

  const { data: userData } = useGetUser();
  const user = userData as UserType;

  const [isAppSettingsModalOpen, setIsAppSettingsModalOpen] = useState(false);

  const chosenLangTranslation = LANGUAGE_LIST!.find(
    ({ value }) => value === user.locale,
  )!.labelTranslation;

  return (
    <>
      <div>
        <Box
          sx={theme => ({
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: theme.other.spacing(2.5),
          })}
        >
          <Text weight={600}>{t('user:appSettings')}</Text>
          <UnstyledButton
            sx={theme => ({
              fontWeight: 600,
              color: theme.fn.primaryColor(),
            })}
            onClick={() => {
              setIsAppSettingsModalOpen(true);
            }}
          >
            {t('common:edit')}
          </UnstyledButton>
        </Box>
        <DataItem
          sx={theme => ({
            marginBottom: theme.other.spacing(2),
          })}
          icon={<GlobeIcon />}
          label={t('user:preferredLanguage')}
          value={t(chosenLangTranslation)}
        />
        <DataItem
          icon={<CalendarIcon />}
          label={t('user:dateFormat')}
          value={user.dateFormat}
        />
      </div>
      <AppSettingsModal
        isOpen={isAppSettingsModalOpen}
        onClose={() => {
          setIsAppSettingsModalOpen(false);
        }}
      />
    </>
  );
};
